import { Box, Flex } from '@chakra-ui/react';

import { Iteration } from 'Component/others';
import { TextRegular, TextSemiBold } from 'UiKit/typography';

import styles from './styles.module.css';

const FilterTabMobile = ({ items, onChange, label, selected }) => {
  const onClickOption = (option) => onChange(option);

  return (
    <Flex className={styles['filter-tab__container']}>
      <Box className={styles['filter-tab__label']}>
        <TextRegular>{label}</TextRegular>
      </Box>

      <Flex className={styles['filter-tab__content']}>
        <Iteration
          items={items}
          render={(item) => {
            const isActive = item?.value === selected?.value;

            return (
              <Box
                className={`${styles['filter-tab__item']} ${isActive && styles['filter-tab__item--active']}`}
                key={item?.value}
                onClick={() => onClickOption(item)}
              >
                <TextSemiBold>{item?.label}</TextSemiBold>
              </Box>
            );
          }}
        />
      </Flex>
    </Flex>
  );
};

export default FilterTabMobile;
